<script setup>
import { ref } from 'vue';
import FieldContainer from './FieldContainer.vue';
import FieldWrapper from './FieldWrapper.vue';
import { fieldEmits, fieldProps, useField } from '@/composables/form/field';

const element = ref();
const props = defineProps(fieldProps({
    type: {
        type: String,
        default: 'input',
    },
}));

const emit = defineEmits(fieldEmits());

const set = (value) => element.value.value = value;
const castStateUsing = (state) => state ?? '';

const field = useField({ props, emit, set, castStateUsing });

const onInput = (event) => {
    field.updateState({
        value: event.target.value ?? null,
        event,
    });
}
</script>

<template>
    <FieldContainer>
        <FieldWrapper>
            <input
                :aria-label="field.label && field.hideLabel ? field.label : undefined"
                ref="element"
                :id="field.id"
                :name="field.name"
                :placeholder="field.placeholder"
                :type="type"
                @input="onInput"
                :disabled="field.disabled"
                :aria-required="field.required"
                :min="min"
                class="
                    grow block focus:outline-none disabled:opacity-50 disabled:bg-gray
                    border-0 focus:ring-0 bg-transparent p-0 placeholder:opacity-50
                " />
        </FieldWrapper>
    </FieldContainer>
</template>
